var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#08C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.984 9.381c.143-.92-.733-1.647-1.551-1.287L6.131 15.25c-.587.258-.544 1.147.065 1.34l3.361 1.072a2.17 2.17 0 0 0 1.897-.289l7.58-5.236c.228-.159.478.167.282.368L13.86 18.13c-.529.546-.424 1.47.213 1.87l6.108 3.83c.685.43 1.567-.002 1.695-.83z"
  })));
};
export default SvgTelegram;